export const buildUtmQueryParams = (utmMedium: string | undefined): [string, string][] => {
  return utmMedium ? [["UtmMedium", utmMedium]] : [];
};
